import { ReactElement } from 'react';

import { AdminService, AnalyticsService, useApiEffect } from '@localstack/services';

import { UsageInsightView } from '~/components/UsageInsights';

export interface UsageInsightsProps {
  orgId: string;
}

export const UsageInsights = ({ orgId }: UsageInsightsProps): ReactElement => {
  const { adminGetUsageInsights, isLoading } = useApiEffect(AdminService, ['adminGetUsageInsights']);

  const fetchData = (...args: Parameters<typeof AnalyticsService.getUsageInsights>) =>
    adminGetUsageInsights(orgId, ...args);

  return <UsageInsightView fetchData={fetchData} isLoading={isLoading} />;
};
